import { render, staticRenderFns } from "./Letreiro.vue?vue&type=template&id=b5acbc22&scoped=true&"
import script from "./Letreiro.vue?vue&type=script&lang=js&"
export * from "./Letreiro.vue?vue&type=script&lang=js&"
import style0 from "./Letreiro.vue?vue&type=style&index=0&id=b5acbc22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5acbc22",
  null
  
)

export default component.exports